import useCreateJobContextValue from 'pages/CreateJob/CreateJob-useCreateJobContextValue';

import useSaveDraft from '../../../CreateJob-useSaveDraft';

const ContainerComponent = ({ children }) => {
  const {
    data: { isLoading, company },
  } = useCreateJobContextValue();

  const showBanner =
    company?.lifecycle === 'registered' || company?.lifecycle === 'onboarded';

  const { handleSubmit } = useSaveDraft();

  const saveDraft = () => handleSubmit();

  return children({
    isLoading: isLoading || !company,
    saveDraft,
    showBanner,
  });
};

ContainerComponent.displayName = 'CompanyDetails-container';

export default ContainerComponent;
